module.exports = __webpack_public_path__ + "img/奖章2级@3x.8eca35df.png";